import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtercount'
})
export class FiltercountPipe implements PipeTransform {

  transform(items: any[], searchText: string,filteredCount:any): any[] {

    if(!searchText) {
      filteredCount.count = items.length;
      return items};
    if (!items){ 
      filteredCount.count =0;
      return [];
    }
    //if (!searchText || searchText.length<=1) return [];
    searchText = searchText.toLowerCase();
    let dat=items.filter((it) => {
      return it.name.toLowerCase().includes(searchText);
    });
    filteredCount.count = dat.length;
    return dat;
  }

}
